/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailTemplateScopeFilter } from './emailTemplateScopeFilter';


export interface EmailTemplateIncludeFilterItems { 
    relation?: EmailTemplateIncludeFilterItems.RelationEnum;
    scope?: EmailTemplateScopeFilter;
}
export namespace EmailTemplateIncludeFilterItems {
    export type RelationEnum = 'emails';
    export const RelationEnum = {
        Emails: 'emails' as RelationEnum
    };
}


